import React from "react"
export function Search(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M7.945 2a5.945 5.945 0 014.68 9.614L18 16.99 16.991 18l-5.377-5.375A5.945 5.945 0 117.946 2zm0 1.427a4.519 4.519 0 100 9.037 4.519 4.519 0 000-9.037z"
        fill="currentColor"
      />
    </svg>
  )
}
